
import createFetch from "@randajan/api-kit/client";


export const apiFetch = createFetch({
    url:"/api",
    // timestamp:true,
    throwError:true,
    resultOnly:true
});